import React from "react";

import HeroSlider from "./HeroSlider";
import AboutSection from "./AboutSection";
import ServiceSection from "./ServiceSection";
import ProjectSection from "./ProjectSection";
import TestimonialSection from "./TestimonialSection";
import BlogSection from "./BlogSection";
import ClientArea from "./ClientArea";
import CTASection from "./CTASection";

const Home = () => {
  return (
    <>
      <HeroSlider />
      <AboutSection />
      <ServiceSection />
      <ProjectSection />
      <CTASection />
      <TestimonialSection />
      <BlogSection />
      <ClientArea />
    </>
  );
};

export default Home;
